import { getFragmentData } from 'gql'

import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { WORKSPACE_GENERAL_CONFIGURATION_FRAGMENT } from './api/fragment'
import { fromDTO } from './api/mapper'
import { GET_WORKSPACE_GENERAL_CONFIGURATION } from './api/query'

import type { UseGetWorkspaceGeneralConfiguration } from './types'
import type {
  GetWorkspaceGeneralConfigurationQuery,
  GetWorkspaceGeneralConfigurationQueryVariables,
  WorkspaceGeneralConfigurationFragmentFragment,
} from 'gql/graphql'

export const useGetWorkspaceGeneralConfiguration = (): UseGetWorkspaceGeneralConfiguration => {
  const { workspaceId } = useWorkspaceParam()

  const { data } = useQuery<
    GetWorkspaceGeneralConfigurationQueryVariables,
    GetWorkspaceGeneralConfigurationQuery,
    WorkspaceGeneralConfigurationFragmentFragment
  >({
    options: {
      select: ({
        workspaceGeneralConfiguration,
      }: GetWorkspaceGeneralConfigurationQuery): WorkspaceGeneralConfigurationFragmentFragment =>
        fromDTO(
          getFragmentData(WORKSPACE_GENERAL_CONFIGURATION_FRAGMENT, workspaceGeneralConfiguration),
        ),
    },
    query: GET_WORKSPACE_GENERAL_CONFIGURATION,
    variables: { workspaceId },
  })

  return { workspaceGeneralConfiguration: data }
}
